/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon8Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 1024 660"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M569.34 418.4v1.63l-1.63-1.63c-25.29 29.65-48.48 53.92-69.55 72.82-21.08 18.91-40.53 33.11-58.34 42.63-17.82 9.52-34.2 14.28-49.16 14.28-30.46 0-55.62-10.2-75.47-30.6-19.86-20.4-29.78-46.23-29.78-77.51 0-19.31 4.9-42.15 14.69-68.53s23.25-52.22 40.39-77.51c28.56-41.34 64.46-76.42 107.7-105.25 44.6-29.64 87.57-44.47 128.91-44.47 34.81 0 63.44 7.14 85.87 21.42 22.44 14.28 33.66 32.3 33.66 54.05 0 16.05-5.58 33.04-16.73 50.99 14.69 0 23.93 1.57 27.74 4.69 3.81 3.13 5.71 10.4 5.71 21.82 0-1.08-.68 4.49-2.04 16.73-1.63 26.92-2.45 52.08-2.45 75.47 0 12.24.13 21.49.41 27.74.27 6.26.82 13.46 1.63 21.62s1.63 14.69 2.45 19.58c2.17 12.79 5.71 25.43 10.61 37.94-16.32 16.05-31.96 27.81-46.91 35.29q-22.44 11.22-45.69 11.22c-41.88 0-62.82-35.08-62.82-105.25 0-8.16.27-14.55.82-19.17Zm24.47-93.42-7.75 2.45c-19.58 5.44-33.72 8.16-42.43 8.16-10.61 0-15.91-2.71-15.91-8.16 0-1.9 2.17-6.94 6.53-15.09 15.23-23.11 22.84-44.87 22.84-65.27 0-11.69-2.04-22.37-6.12-32.02s-8.57-14.48-13.46-14.48c-4.35 0-11.01 4.63-19.99 13.87-25.29 27.47-45.35 55.62-60.17 84.44-14.83 28.83-22.23 54.53-22.23 77.1 0 14.96 3.06 27.33 9.18 37.12s13.8 14.69 23.05 14.69c7.88 0 22.64-8.43 44.26-25.29s45.89-39.16 72.82-66.9l11.01-8.97-1.63-1.63ZM-.02 660.06V1.01h219.93v101.45H109.57l4.44-5.92V567.5l-7.41-8.89h113.3v101.45zm803.19 0V558.61h111.08l-4.44 5.92V93.57l7.4 8.89H803.17V1.01h220.67v659.05z"
        }
      ></path>
    </svg>
  );
}

export default Icon8Icon;
/* prettier-ignore-end */
